import { NgModule } from '@angular/core';
import { CharOnlyWithsplDirective } from './char-only-withspl/char-only-withspl.directive';
import { CharactersOnlyDirective } from './char-only/char-only.directive';
import { TrimDirective } from './trim-directive/trim.directive';
import { NumbersOnlyDirective } from './number-only/numbers-only.directive';

@NgModule({
    imports: [],
    declarations: [TrimDirective, CharOnlyWithsplDirective, CharactersOnlyDirective, NumbersOnlyDirective],
    exports: [TrimDirective, CharOnlyWithsplDirective, CharactersOnlyDirective, NumbersOnlyDirective]
})
export class DirectivesModule { }
